/*
 * @Author: cc
 * @Date: 2019-12-31 16:39:39
 * @LastEditTime : 2019-12-31 17:34:09
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\multiImgsWatermark\multiImgsWatermark.js
 * @Description: 一键水印弹窗
 */
angular.module('multiImgsWatermarkModule', []).controller('multiImgsWatermarkCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    'params',
    'editPictureService',
    'trsHttpService',
    'jsonArrayToStringService',
    'publicToolService',
    function($scope, $q, $modalInstance, params, editPictureService, trsHttpService, jsonArrayToStringService, publicToolService) {
        initStatus();
        initData();
        getWatermarkList();

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.default = {
                width: 522,
                height: 362,
            };
            $scope.status = {
                // 是否使用水印
                // isSet: '0',
                // 水印透明度
                waterMarkOpc: 100,
                // 默认水印位置，右下
                locationType: '4',
                // 获取水印id
                siteId: params.siteId,
                // 产品id
                productId: params.productId || publicToolService.getNewmediaTypeAndProductId().productId || '',
                // 类型
                mediaType: params.mediaType || publicToolService.getNewmediaTypeAndProductId().mediaType || '',
                // 水印宽度
                // numWidth: 0,
                // 水印高度
                // numHeight: 0,
                // 水印大小比例
                ratio: 45,
                // 水印x位置
                drawX: 0,
                // 水印y位置
                drawY: 0,
                // 是否开启位移
                isMove: false,
                // 位移暂存数据
                moveData: [0, 0],
                moveDraw: [0, 0],
                isShowLeft: true
            };
            $scope.data = {
                // 设置画图的定位
                drawSit: {
                    '1': [0, 0]
                },
                locations: [
                    {
                        type: '1',
                        name: '左上'
                    }, {
                        type: '7',
                        name: '中上'
                    }, {
                        type: '5',
                        name: '右上'
                    }, {
                        type: '8',
                        name: '左中'
                    }, {
                        type: '2',
                        name: '居中'
                    }, {
                        type: '9',
                        name: '右中'
                    }, {
                        type: '6',
                        name: '左下'
                    }, {
                        type: '3',
                        name: '中下'
                    }, {
                        type: '4',
                        name: '右下'
                    }
                ]
            };
            $scope.drawImg = null;
        }

        /**
         * [initData description]初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {}

        /**
         * [getWatermarkList description] 获取水印列表
         *
         * @return  {[type]}   [return description]
         */
        function getWatermarkList() {
            if (!$scope.status.siteId && !$scope.status.productId) {return;}
            editPictureService.getWatermarkList($scope.status.siteId, $scope.status.productId, $scope.status.mediaType).then(function(data) {
                $scope.status.watermarkList = [];
                for (var i = 0; i < data.length; i++) {
                    // 处理图片跨域问题
                    var watermarkTypeArray = data[i].V.split('/');
                    watermarkTypeArray.splice(0, 3);
                    var realV = '/' + watermarkTypeArray.join('/');
                    $scope.status.watermarkList[i] = {
                        name: data[i].N,
                        value: realV,
                    };
                }
                $scope.status.watermarkList.unshift({ name: '--请选择一个水印--', value: '-1', });
                $scope.watermarkSelected = $scope.status.watermarkList[0];
                $scope.status.watermarkType = $scope.watermarkSelected.value;
            });
        }

        /**
         * [dueMove description]
         *
         * @return  {[type]}   [return description]
         */
        function dueMove() {
            $scope.canvas.onmousedown = function(event) {
                $scope.moveData = [event.clientX, event.clientY];
                $scope.moveDraw = [angular.copy($scope.status.drawX), angular.copy($scope.status.drawY)];
                $scope.isMove = true;
                $scope.status.locationType = '0';
            };
            $scope.canvas.onmouseup = function() {
                $scope.moveData = [0, 0];
                $scope.isMove = false;
            };
            $scope.canvas.onmousemove = function(event) {
                if ($scope.isMove){
                    // 这两句是判断是否超出空间的，为了不让水印超出
                    $scope.status.drawX = $scope.moveDraw[0] + (event.clientX - $scope.moveData[0]) <= 0 ? 0 : $scope.moveDraw[0] + (event.clientX - $scope.moveData[0]) >= $scope.default.width - $scope.status.numWidth ? $scope.default.width - $scope.status.numWidth : $scope.moveDraw[0] + (event.clientX - $scope.moveData[0]);
                    $scope.status.drawY = $scope.moveDraw[1] + (event.clientY - $scope.moveData[1]) <= 0 ? 0 : $scope.moveDraw[1] + (event.clientY - $scope.moveData[1]) >= $scope.default.height - $scope.status.numHeight ? $scope.default.height - $scope.status.numHeight : $scope.moveDraw[1] + (event.clientY - $scope.moveData[1]);
                    $scope.drawCanvas();
                }
            };
        }

        /**
         * [cancel description] 取消图片编辑 关闭窗口
         *
         * @return  {[type]}   [return description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [setSizeType description] 设置图片是否使用水印
         * @param   {[type]}  value  [value description]
         * @return  {[type]}         [return description]
         */
        $scope.setIsSet = function(value) {
            $scope.status.isSet = value;
        };

        /**
         * [setWatermark description]添加水印
         *
         * @param  {[type]}  watermark   [watermarkType description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.setWatermark = function(watermark) {
            // 如果初始化的时候进行获取ctx对象
            $scope.watermarkSelected = watermark;
            var watermarkType = watermark.value;
            if (!$scope.ctx){
                $scope.canvas = document.getElementById('multiImgsCanvas');
                $scope.ctx = $scope.canvas.getContext('2d'); // 赋予ctx绘制对象
                dueMove();
            }
            if (watermarkType === '-1'){
                $scope.drawImg = null;
                $scope.ctx.clearRect(0, 0, $scope.default.width, $scope.default.height);
                return;
            }
            $scope.status.watermarkType = watermarkType;
            $scope.drawImg = new Image();
            $scope.drawImg.src = $scope.status.watermarkType;
            $scope.drawImg.onload = function() {
                getImgSize();
            };
        };

        /**
         * [setLocation description] 设置水印位置
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.setLocation = function(type) {
            $scope.status.locationType = type;
            if ($scope.data.drawSit[type]) {
                $scope.status.drawX = $scope.data.drawSit[type][0];
                $scope.status.drawY = $scope.data.drawSit[type][1];
            }
            $scope.drawCanvas();
        };

        /**
         * [changeDrawSit description]设置水印位置数组
         *
         * @return  {[type]}   [return description]
         */
        $scope.changeDrawSit = function() {
            var betweenX = $scope.default.width - $scope.status.numWidth;
            var betweenY = $scope.default.height - $scope.status.numHeight;
            $scope.data.drawSit['2'] = [betweenX / 2, betweenY / 2];
            $scope.data.drawSit['3'] = [betweenX / 2, betweenY];
            $scope.data.drawSit['4'] = [betweenX, betweenY];
            $scope.data.drawSit['5'] = [betweenX, ''];
            $scope.data.drawSit['6'] = ['', betweenY];
            $scope.data.drawSit['7'] = [betweenX / 2, ''];
            $scope.data.drawSit['8'] = ['', betweenY / 2];
            $scope.data.drawSit['9'] = [betweenX, betweenY / 2];
            $scope.setLocation($scope.status.locationType);
        };

        /**
         * [getImgSize description]
         *
         * @return  {[type]}   [return description]
         */
        function getImgSize() {
            $scope.status.numWidth = $scope.default.width * $scope.status.ratio / 100;
            $scope.status.numHeight = $scope.status.numWidth / $scope.drawImg.width * $scope.drawImg.height;
            // $scope.$apply();
            $scope.changeDrawSit();
        }

        /**
         * [drawCanvas description] 绘制canvas
         * @return  {[type]}        [return description]
         */
        $scope.drawCanvas = function() {
            if (!$scope.ctx) {return;}
            $scope.ctx.clearRect(0, 0, $scope.default.width, $scope.default.height);
            $scope.ctx.globalAlpha = $scope.status.waterMarkOpc / 100;
            $scope.ctx.drawImage($scope.drawImg, $scope.status.drawX, $scope.status.drawY, $scope.status.numWidth, $scope.status.numHeight);
        };

        /**
         * [confirm description]确定 流程：在每次进行水印修改前进行原始图片的请求
         *
         * @return  {[type]}   [return description]
         */
        $scope.confirm = function() {
            var param = {};
            var reg = /\=.*/;
            var picList = {
                list: [],
            };
            var FileUrlList = {
                list: []
            };
            // 过滤掉gif图片格式
            params.images.forEach((item, index) => {
                if (item.APPFILE.substring(item.APPFILE.lastIndexOf('.')).toLowerCase().indexOf('.gif') > -1) {
                    params.images.splice(params.images.indexOf(item), 1);
                }
            });
            params.images.forEach((item) => {
                picList.list.push(item.APPFILE);
                FileUrlList.list.push(item.PERPICURL);
            });
            var backparam = {
                serviceid: 'mlf_picrecover',
                methodname: 'getPicListOriginalPic',
                picList: picList,
                FileUrlList: FileUrlList
            };
            // 判断还原原始图片
            if ($scope.status.isSet === '0'){
                confimeSend(backparam).then((data) => {
                    $modalInstance.close(data);
                }, () => {
                    $modalInstance.dismiss();
                });
                // 进入水印添加
            } else {
                // 在处理图片前先进行水印的处理
                editPictureService.ScaleWatermark($scope.status.watermarkType, $scope.status.numWidth, $scope.status.numHeight, $scope.status.waterMarkOpc / 100).then((response) => {
                    // 请求出原始图片
                    confimeSend(backparam).then((data) => {
                        var changeList = {
                            list: [],
                        };
                        var FileUrlList = {
                            list: []
                        };
                        Object.keys(data.LIST).forEach((item) => {
                            changeList.list.push(data.LIST[item].FILENAME);
                        });
                        params.images.forEach((item) => {
                            // changeList.list.push(item.APPFILE);
                            FileUrlList.list.push(item.PERPICURL);
                        });
                        param = {
                            serviceid: 'mlf_image',
                            methodname: 'addWatermarkToPics',
                            WMPIC: response.match(reg, '')[0].slice(1),
                            WMPOS: `4,${Math.round($scope.status.drawY)},${Math.round($scope.status.drawX)},${Math.round($scope.default.width)},${Math.round($scope.default.height)},${Math.round($scope.status.locationType)}`,
                            picList: changeList,
                            FileUrlList: FileUrlList
                        };
                        // 请求水印处理后的图片并进行赋值给上一接口数据（保证回填的读取url不变）
                        confimeSend(param).then((datas) => {
                            var i = 0;
                            var watermarkPic = {
                                LIST: {}
                            };
                            Object.keys(datas.LIST).forEach((needKey) => {
                                // data.LIST[needKey] = datas.LIST[data.LIST[needKey].FILENAME];
                                watermarkPic.LIST[params.images[i].APPFILE] = datas.LIST[needKey];
                                i++;
                            });
                            $modalInstance.close(watermarkPic);
                        }, () => {
                            $modalInstance.dismiss();
                        });
                    }, () => {
                        $modalInstance.dismiss();
                    });
                });
            }
        };

        /**
         * [confimeSend description]请求处理
         *
         * @param  {[type]}  param   [param description]
         *
         * @return  {[type]}   [return description]
         */
        function confimeSend(param) {
            var deffer = $q.defer();
            param = jsonArrayToStringService.jsonArrayToString(param);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), param, 'post').then(function(data) {
                deffer.resolve(data);
            }, function() {
                deffer.reject();
            });
            return deffer.promise;
        }

        // 监听水印透明度的变化
        $scope.$watch(function () {
            return {
                opacity: $scope.status.waterMarkOpc,
                ratio: $scope.status.ratio
            };
        }, function (newValue, oldValue) {
            if ((newValue.opacity !== oldValue.opacity || newValue.ratio !== oldValue.ratio) && $scope.status.watermarkType !== '-1') {
                getImgSize();
            }
        }, true);
    },
]);
